
export default class ToolbarModel {
    public public: boolean = false;
}